import { dashboardWidgets } from '~/config/widgets/dashboardWidgets';
import { AppRoute } from '@agentselly/immodossier-shared';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_$CONTACTID_DOSSIER_$DOSSIERID_HOME,
  dashboardWidgets,
);
